import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { emailLoginAction, emailPasswordLoginAction } from '../../redux/actions/authAction';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAuth } from '../../context/AuthContext';
import successToast from '../../components/toast/successToast';
import errorToast from '../../components/toast/errorToast';
import logo from '../../assets/images/acumenVelocityLogo.svg';
import { Image, Spinner } from 'react-bootstrap'
/** Login using Email */
const EmailLogin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { fetchMe } = useAuth();
    const [loading, setLoading] = useState(false)
    let { id } = useParams();

    const initialValues = {
        email: '',
        password: '',
    }

    const onSuccess = async (data) => {
        if (data.data.data.requires_2fa) {
            sessionStorage.setItem('2fa_session_token', data.data.data.session_token);
            setLoading(false);
            navigate('/verify-2fa');
            return;
        }
        if (data.data.data.basicUserToken || data.data.data.proUserToken) {
            sessionStorage.setItem('basicUserToken', data.data.data.basicUserToken);
            sessionStorage.setItem('proUserToken', data.data.data.proUserToken);
            setLoading(false);
            navigate('/choose-version');
        } else {
            await fetchMe();
            setLoading(false);
            if (id) {
                navigate('/translations');
            } else if (data.data.data.user.is_demo) {
                navigate('/portals');
            } else {
                navigate('/over-view');
            }
        }
        successToast(data.data.message);
    }

    const onError = (data) => {
        errorToast(data.data.message);
        setLoading(false)
    }

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required("Required").email("Invaild Email"),
        password: Yup.string()
            .required("Required")
    });

    const onSubmit = (values) => {
        if (id) {
            const dispatchingValues = {
                email: values.email,
                password: values.password,
                is_translateLogin: id ? true : false,
                portal_id: id
            }
            dispatch(emailLoginAction(dispatchingValues, onSuccess, onError))
        } else {
            const dispatchingValues = {
                email: values.email,
                password: values.password
            }
            dispatch(emailPasswordLoginAction(dispatchingValues, onSuccess, onError))
        }
        setLoading(true)
    }


    return (
        <div className='d-flex flex-column align-items-center justify-content-center w-100' style={{ height: '100vh', backgroundColor: '#e9eef7' }}>
            <div className='d-flex gap-2 justify-content-start align-items-center cursor_pointer w-100' style={{ height: '4rem' }} onClick={() => navigate('/')}>
                <Image alt='logo' src={logo} height={40} className='mx-1' />
                <p className='name fs_16 fw_700'>Acumen Translation Hub</p>
            </div>
            <div className=" d-flex justify-content-center align-items-center flex-grow-1 text-start" style={{ maxWidth: '30rem', width: '100%' }}>
                <div className="border bg-white p-4" style={{ width: '100%', borderRadius: '8px' }}>
                    <h5 className="card-title mb-4 text-nowrap">Email Login</h5>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        <Form>
                            <div className="mb-3">
                                <label htmlFor="email" className='form-label'>Email : </label>
                                <Field name="email">
                                    {({ field, meta }) => (
                                        <div className="position-relative">
                                            <input {...field} placeholder="Enter your email" id="email" className="input-field" type="email" style={{ width: '90%' }} />
                                            <ErrorMessage name="email" component="div" className="text-danger" />
                                        </div>
                                    )}
                                </Field>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="password" className='form-label'>Password:</label>
                                <Field name="password">
                                    {({ field, meta }) => (
                                        <div className="position-relative">
                                            <input {...field} placeholder="Enter your password" id="password" className="input-field" type="password" style={{ width: '90%' }} />
                                            <ErrorMessage name="password" component="div" className="text-danger" />
                                        </div>
                                    )}
                                </Field>
                                <div className='mt-2 d-flex justify-content-end cursor-pointer' onClick={() => navigate('/forgot-password')}>
                                    <span className='text-primary cursor_pointer'>Forgot Password?</span>
                                </div>
                            </div>
                            {loading && <div className="d-flex align-items-center text-center"><Spinner size='sm' className='text-primary' /> <span className='ms-2'>Logging in...</span></div>}
                            <div className='d-flex justify-content-between mt-4'>
                                <button type="submit" className="btn btn-primary" disabled={loading}>Login</button>
                                <button type="" className="btn btn-primary" disabled={loading} onClick={() => navigate('/sign-up')}>Signup</button>
                            </div>
                        </Form>
                    </Formik>
                </div>
            </div>
        </div>
    );
};

export default EmailLogin;
